import { useEffect } from 'react';
import {
  Dialog,
  ButtonSize,
  Typography,
  ButtonVariant,
  PrimaryButton,
} from '@uni-of-exeter/digital.lib.react.ui.kit';

import './resource-type.css';
import { APP_TEXT } from '../../const/app-text';

// ------------------------------------------------------------

const text = APP_TEXT.components.resourceTypeModal;

export interface ResourceTypeModalProps {
  isOpen: boolean;
  onSave?: () => void;
  onClose: () => void;
}

const ResourceTypeModal = ({ isOpen, onClose }: ResourceTypeModalProps) => {
  useEffect(() => {
    if (isOpen === true) {
      const rootElement = document.getElementById('root');
      if (!rootElement) {
        return;
      }
      rootElement.style.filter = 'blur(4px)';
    } else {
      const rootElement = document.getElementById('root');
      if (!rootElement) {
        return;
      }
      rootElement.style.filter = '';
    }
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      footer={<></>}
      className="resourceTypeModal"
    >
      <div
        className="resourceTypeModalWrapper"
        aria-modal
        role="alertdialog"
        aria-label="Resource Type Modal"
      >
        <div className="resourceTypeModalContent">
          <Typography
            variant="h2"
            fontWeight={700}
          >
            {text.title}
          </Typography>

          <div className="resourceTypeModalContentList">
            {text.content.map((content) => (
              <div key={content.title}>
                <Typography
                  variant="body"
                  fontWeight={700}
                >
                  {content.title}
                </Typography>
                <Typography variant="body">{content.body}</Typography>
              </div>
            ))}
          </div>
        </div>

        <div className="resourceTypeModalButton">
          <PrimaryButton
            variant={ButtonVariant.Solid}
            size={ButtonSize.Large}
            onClick={onClose}
          >
            {text.close}
          </PrimaryButton>
        </div>
      </div>
    </Dialog>
  );
};

export default ResourceTypeModal;
